import { useQuery } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";

const useMe = (queryOptions = {}) => {
  return useQuery({
    queryKey: ["me"],
    staleTime: 1000 * 60 * 2, // 2 minutes,
    queryFn: async () => {
      const response = await apiClient.get(`users/me`);

      const user = response?.data;
      const userId = user?.id;
      if (userId) {
        // Identify user in Clarity
        window.clarity?.("identify", userId);

        // Identify user in HelpScout
        window.Beacon("identify", {
          name: user?.name,
          email: user?.email,
          phone: user?.phone,
        });

        // Show NPS when user has existed for a month
        const onboardedDate =
          user?.siteSettings?.onboardedAt &&
          new Date(user?.siteSettings?.onboardedAt);

        const monthSinceOnboarded =
          onboardedDate instanceof Date &&
          (new Date() - onboardedDate) / (1000 * 60 * 60 * 24 * 30);

        if (monthSinceOnboarded >= 1) {
          window.Beacon("show-message", "bef1bb7d-3955-4e36-8ab1-cb8e4d676b99");
        }
      }

      return response;
    },
    ...queryOptions,
  });
};

export { useMe };
